import estilos from './Cabecalho.module.css';

export default function Cabecalho() {
  return (
    <header className={estilos.cabecalho}>
      <div className={estilos.wrapper}>
        <div className={estilos.brand}>
          <span className={estilos.logo}>SkySense</span>
          <p className={estilos.subtitle}>Busca inteligente de passagens aéreas</p>
        </div>
        <nav className={estilos.navegacao}>
          <a href="#busca">Buscar</a>
          <a href="#ofertas">Ofertas</a>
          <a href="#vantagens">Vantagens</a>
        </nav>
        <a className={estilos.contato} href="#contato">
          Começar
        </a>
      </div>
    </header>
  );
}
